import type { PartialTheme } from '@main/theme';
import { createTheme, DEFAULT_CONFIGURABLE_COLORS } from '@main/theme';

import { PrivacyCenterGlobalStyles } from './global-styles';

/**
 * Theme input
 */
export const DEFAULT_THEME_INPUT: PartialTheme = {
  name: 'privacy-center-default',
  colors: DEFAULT_CONFIGURABLE_COLORS,
  GlobalStyles: PrivacyCenterGlobalStyles,
};

/**
 * If the schema of the theme changes, we can get build errors with type safety
 * because of the following order of operations:
 *
 * 1. Break schema i.e. theme.buttonStyles -> theme.componentStyles
 * 2. Access new code with theme.componentStyles.primary, this type checks
 * 3. Push code
 * 4. Production gets new code but has cached theme to local storage
 * 5. Production reads old schema and theme.componentStyles.primary causing build error to occur
 *
 * Here we just keep a fully type safe theme object and merge them together to ensure that
 * the type safety is always true
 */
export const EMPTY_THEME_INPUT: Required<PartialTheme> = {
  name: 'type-safe',
  colors: { primary: '', secondary: '' },
  GlobalStyles: PrivacyCenterGlobalStyles,
  componentStyles: {},
  textStyles: {},
};

/**
 * The color theme definition for the app
 */
export const PRIVACY_CENTER_THEME = createTheme(DEFAULT_THEME_INPUT);
